var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 510"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__f",
    x1: 206.639,
    x2: 206.639,
    y1: -1224.396,
    y2: -1167.894,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__g",
    x1: 400.757,
    x2: 400.757,
    y1: -1235.691,
    y2: -1202.241,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__h",
    x1: 245.357,
    x2: 245.357,
    y1: -1231.347,
    y2: -1155.303,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__i",
    x1: 362.04,
    x2: 362.04,
    y1: -1212.232,
    y2: -1142.852,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__b"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__j",
    x1: 303.698,
    x2: 303.698,
    y1: -1245.248,
    y2: -1169.224,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__k",
    x1: 226.244,
    x2: 226.244,
    y1: -1175.306,
    y2: -1146.93,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__l",
    x1: 263.523,
    x2: 263.523,
    y1: -1178.89,
    y2: -1121.864,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__m",
    x1: 303.698,
    x2: 303.698,
    y1: -1176.61,
    y2: -1095.105,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#174461",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__n",
    x1: 343.873,
    x2: 343.873,
    y1: -1163.232,
    y2: -1135.228,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__c"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__o",
    x1: 381.152,
    x2: 381.152,
    y1: -1178.239,
    y2: -1129.99,
    gradientTransform: "rotate(180 279.349 -387.39)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__c"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__p",
    x1: 121.751,
    x2: 180.937,
    y1: 277.404,
    y2: 315.452,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__b"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__q",
    x1: 352.889,
    x2: 391.542,
    y1: 285.751,
    y2: 344.937,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__b"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__r",
    x1: 215.442,
    x2: 273.244,
    y1: 189.925,
    y2: 189.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__s",
    x1: 229.271,
    x2: 101.537,
    y1: 174.242,
    y2: 109.017,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__d"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__t",
    x1: 332.499,
    x2: 225.379,
    y1: 249.506,
    y2: 142.385,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__d"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__u",
    x1: 235.027,
    x2: 269.818,
    y1: 152.509,
    y2: 187.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf5ff"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9da6ac"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__v",
    x1: 229.468,
    x2: 293.224,
    y1: 146.475,
    y2: 210.23,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__e"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__w",
    x1: -738.888,
    x2: -684.234,
    y1: -1004.307,
    y2: -949.653,
    gradientTransform: "rotate(166.41 -300.136 -346.918)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__e"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__x",
    x1: 255,
    x2: 255,
    y1: 308.292,
    y2: 340.955,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__d"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "apps_svg__y",
    x1: 216.244,
    x2: 240.808,
    y1: -888.016,
    y2: -888.016,
    gradientTransform: "rotate(90 -384.279 -248.737)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#apps_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__f)",
    d: "M328.29 457.893L353.397 510h20.284c12.338 0 19.47-13.993 12.22-23.976L369.543 463.5a123.849 123.849 0 01-23.64-72.779v-17.648l-30.594-17.534v42.112c0 21.642 4.544 42.73 12.981 60.242z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__g)",
    d: "M136.319 510h20.284l25.106-52.107c8.438-17.512 12.982-38.599 12.982-60.242v-42.112l-30.594 17.534v17.648c0 26.147-8.275 51.623-23.64 72.78L124.1 486.024c-7.25 9.983-.119 23.976 12.219 23.976z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__h)",
    d: "M273.286 397.65c0 21.643 1.378 42.73 3.936 60.242L284.835 510h68.562l-25.106-52.107c-8.438-17.512-12.982-38.599-12.982-60.242v-42.112l-42.023-24.084z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__i)",
    d: "M181.71 457.893L156.603 510h68.562l7.612-52.107c2.558-17.512 3.936-38.599 3.936-60.242v-66.196l-42.023 24.084v42.112c.001 21.642-4.543 42.73-12.98 60.242z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__j)",
    d: "M236.714 397.65c0 21.643-1.378 42.73-3.936 60.242L225.165 510h59.669l-7.612-52.107c-2.558-17.512-3.936-38.599-3.936-60.242v-66.196L255 320.974l-18.286 10.48z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__k)",
    d: "M345.903 390.72v-17.648l-30.594-17.534v42.112c0 7.813.601 15.55 1.755 23.077H349.6a123.774 123.774 0 01-3.697-30.007z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__l)",
    d: "M315.309 397.65v-42.112l-42.023-24.084v66.196c0 7.813.182 15.55.532 23.077h43.245a152.626 152.626 0 01-1.754-23.077z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__m)",
    d: "M273.818 420.727a498.201 498.201 0 01-.532-23.077v-66.196L255 320.974l-18.286 10.48v66.196c0 7.813-.182 15.55-.532 23.077z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__n)",
    d: "M236.182 420.727c.35-7.526.532-15.264.532-23.077v-66.196l-42.023 24.084v42.112c0 7.813-.601 15.55-1.755 23.077z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__o)",
    d: "M192.937 420.727a152.496 152.496 0 001.755-23.077v-42.112l-30.594 17.534v17.648c0 10.176-1.259 20.249-3.696 30.007z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__p)",
    d: "M171.039 361.092V202.558l-56.155 56.155a127.44 127.44 0 00-37.326 90.113c0 6.774 5.492 12.266 12.266 12.266z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__q)",
    d: "M338.961 361.092V202.558l56.155 56.155a127.436 127.436 0 0137.326 90.113c0 6.774-5.492 12.266-12.266 12.266z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__r)",
    d: "M223.601 14.498a269.998 269.998 0 00-64.483 175.108V379.85h191.765V189.605A270.003 270.003 0 00286.4 14.497c-16.471-19.33-46.329-19.33-62.799.001z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__s)",
    d: "M350.883 379.849V189.605A270.003 270.003 0 00286.4 14.497C278.164 4.833 266.582 0 255 0v379.849z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__t)",
    d: "M207.809 125.722c-27.064 27.064-28.877 68.227-1.813 95.291l144.887 144.8V189.605a270 270 0 00-.797-20.524l-46.079-46.079c-27.065-27.064-69.134-24.344-96.198 2.72z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 254.717,
    cy: 172.199,
    r: 51.252,
    fill: "url(#apps_svg__u)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__v)",
    d: "M304.007 123.002c-27.064-27.064-70.946-27.064-98.01 0s-27.064 70.946 0 98.01 70.941 27.059 98.005-.005 27.069-70.94.005-98.005zM221.709 205.3c-18.39-18.39-18.384-48.201 0-66.585 18.39-18.39 48.195-18.39 66.585 0 18.384 18.384 18.39 48.195 0 66.585-18.385 18.384-48.201 18.384-66.585 0z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__w)",
    d: "M285.902 121.264c-28.025-17.066-64.577-8.182-81.643 19.843s-8.178 64.571 19.847 81.636c28.019 17.062 64.567 8.184 81.632-19.841s8.183-64.576-19.836-81.638zm-55.387 90.957c-22.213-13.526-29.248-42.495-15.726-64.701 13.526-22.213 42.489-29.252 64.701-15.726 22.206 13.522 29.252 42.489 15.726 64.701-13.522 22.206-42.495 29.248-64.701 15.726z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__x)",
    d: "M159.117 291.985h191.765v57.978H159.117z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apps_svg__y)",
    d: "M161.64 384.15h186.72c5.737 0 10.388-4.651 10.388-10.388v-33.32c0-5.737-4.651-10.388-10.388-10.388H161.64c-5.737 0-10.388 4.651-10.388 10.388v33.32c-.001 5.737 4.65 10.388 10.388 10.388z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTAgNTEwIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMCA1MTAiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxsaW5lYXJHcmFkaWVudCBpZD0iU1ZHSURfMV8iIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIC0xIDU1OC42OTggLTc3NC43ODEpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjIwNi42MzkiIHgyPSIyMDYuNjM5IiB5MT0iLTEyMjQuMzk2IiB5Mj0iLTExNjcuODk0Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmNlNDciLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZjkzNTYiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0ibGcxIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZjc1NWMiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZjQxODEiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iU1ZHSURfMl8iIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIC0xIDU1OC42OTggLTc3NC43ODEpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjQwMC43NTciIHgyPSI0MDAuNzU3IiB4bGluazpocmVmPSIjbGcxIiB5MT0iLTEyMzUuNjkxIiB5Mj0iLTEyMDIuMjQxIi8+PGxpbmVhckdyYWRpZW50IGlkPSJTVkdJRF8zXyIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgLTEgNTU4LjY5OCAtNzc0Ljc4MSkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMjQ1LjM1NyIgeDI9IjI0NS4zNTciIHkxPSItMTIzMS4zNDciIHkyPSItMTE1NS4zMDMiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2U0ZTA4ZSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzZmYTk1MyIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJsZzIiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmNDE4MSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzg0MzU2MSIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJTVkdJRF80XyIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgLTEgNTU4LjY5OCAtNzc0Ljc4MSkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMzYyLjA0IiB4Mj0iMzYyLjA0IiB4bGluazpocmVmPSIjbGcyIiB5MT0iLTEyMTIuMjMyIiB5Mj0iLTExNDIuODUyIi8+PGxpbmVhckdyYWRpZW50IGlkPSJTVkdJRF81XyIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgLTEgNTU4LjY5OCAtNzc0Ljc4MSkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMzAzLjY5OCIgeDI9IjMwMy42OTgiIHkxPSItMTI0NS4yNDgiIHkyPSItMTE2OS4yMjQiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzdhY2JmZiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQ1YTJlMCIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJTVkdJRF82XyIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgLTEgNTU4LjY5OCAtNzc0Ljc4MSkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMjI2LjI0NCIgeDI9IjIyNi4yNDQiIHkxPSItMTE3NS4zMDYiIHkyPSItMTE0Ni45MyI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmY5MzU2IiBzdG9wLW9wYWNpdHk9IjAiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZjc1NWMiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iU1ZHSURfN18iIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIC0xIDU1OC42OTggLTc3NC43ODEpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjI2My41MjMiIHgyPSIyNjMuNTIzIiB5MT0iLTExNzguODkiIHkyPSItMTEyMS44NjQiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzQzNzY1YSIgc3RvcC1vcGFjaXR5PSIwIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDM3NjVhIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9IlNWR0lEXzhfIiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAtMSA1NTguNjk4IC03NzQuNzgxKSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIzMDMuNjk4IiB4Mj0iMzAzLjY5OCIgeTE9Ii0xMTc2LjYxIiB5Mj0iLTEwOTUuMTA1Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxNzQ0NjEiIHN0b3Atb3BhY2l0eT0iMCIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE3NDQ2MSIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJsZzMiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzg0MzU2MSIgc3RvcC1vcGFjaXR5PSIwIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjM2EyZjRkIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9IlNWR0lEXzlfIiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAtMSA1NTguNjk4IC03NzQuNzgxKSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIzNDMuODczIiB4Mj0iMzQzLjg3MyIgeGxpbms6aHJlZj0iI2xnMyIgeTE9Ii0xMTYzLjIzMiIgeTI9Ii0xMTM1LjIyOCIvPjxsaW5lYXJHcmFkaWVudCBpZD0iU1ZHSURfMTBfIiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAtMSA1NTguNjk4IC03NzQuNzgxKSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIzODEuMTUyIiB4Mj0iMzgxLjE1MiIgeGxpbms6aHJlZj0iI2xnMyIgeTE9Ii0xMTc4LjIzOSIgeTI9Ii0xMTI5Ljk5Ii8+PGxpbmVhckdyYWRpZW50IGlkPSJTVkdJRF8xMV8iIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMTIxLjc1MSIgeDI9IjE4MC45MzciIHhsaW5rOmhyZWY9IiNsZzIiIHkxPSIyNzcuNDA0IiB5Mj0iMzE1LjQ1MiIvPjxsaW5lYXJHcmFkaWVudCBpZD0iU1ZHSURfMTJfIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjM1Mi44ODkiIHgyPSIzOTEuNTQyIiB4bGluazpocmVmPSIjbGcyIiB5MT0iMjg1Ljc1MSIgeTI9IjM0NC45MzciLz48bGluZWFyR3JhZGllbnQgaWQ9IlNWR0lEXzEzXyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIyMTUuNDQyIiB4Mj0iMjczLjI0NCIgeTE9IjE4OS45MjUiIHkyPSIxODkuOTI1Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNlZGY1ZmYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNjN2U5ZmYiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0ibGc0Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiM3YWNiZmYiIHN0b3Atb3BhY2l0eT0iMCIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzJmNzNhMCIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJTVkdJRF8xNF8iIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMjI5LjI3MSIgeDI9IjEwMS41MzciIHhsaW5rOmhyZWY9IiNsZzQiIHkxPSIxNzQuMjQyIiB5Mj0iMTA5LjAxNyIvPjxsaW5lYXJHcmFkaWVudCBpZD0iU1ZHSURfMTVfIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjMzMi40OTkiIHgyPSIyMjUuMzc5IiB4bGluazpocmVmPSIjbGc0IiB5MT0iMjQ5LjUwNiIgeTI9IjE0Mi4zODUiLz48bGluZWFyR3JhZGllbnQgaWQ9IlNWR0lEXzE2XyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIyMzUuMDI3IiB4Mj0iMjY5LjgxOCIgeTE9IjE1Mi41MDkiIHkyPSIxODcuMyI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmZmIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZWRmNWZmIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImxnNSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZGZkZmRmIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjOWRhNmFjIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9IlNWR0lEXzE3XyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIyMjkuNDY4IiB4Mj0iMjkzLjIyNCIgeGxpbms6aHJlZj0iI2xnNSIgeTE9IjE0Ni40NzUiIHkyPSIyMTAuMjMiLz48bGluZWFyR3JhZGllbnQgaWQ9IlNWR0lEXzE4XyIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgtLjk3MiAuMjM2IC0uMjM2IC0uOTcyIC02NzMuNzQgLTYxMy4yOSkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iLTczOC44ODgiIHgyPSItNjg0LjIzNCIgeGxpbms6aHJlZj0iI2xnNSIgeTE9Ii0xMDA0LjMwNyIgeTI9Ii05NDkuNjUzIi8+PGxpbmVhckdyYWRpZW50IGlkPSJTVkdJRF8xOV8iIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMjU1IiB4Mj0iMjU1IiB4bGluazpocmVmPSIjbGc0IiB5MT0iMzA4LjI5MiIgeTI9IjM0MC45NTUiLz48bGluZWFyR3JhZGllbnQgaWQ9IlNWR0lEXzIwXyIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgwIDEgLTEgMCAtNjMzLjAxNiAxMzUuNTQyKSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIyMTYuMjQ0IiB4Mj0iMjQwLjgwOCIgeGxpbms6aHJlZj0iI2xnMSIgeTE9Ii04ODguMDE2IiB5Mj0iLTg4OC4wMTYiLz48Zz48Zz48cGF0aCBkPSJtMzI4LjI5IDQ1Ny44OTMgMjUuMTA3IDUyLjEwN2gyMC4yODRjMTIuMzM4IDAgMTkuNDctMTMuOTkzIDEyLjIyLTIzLjk3NmwtMTYuMzU4LTIyLjUyNGMtMTUuMzY1LTIxLjE1Ni0yMy42NC00Ni42MzItMjMuNjQtNzIuNzc5di0xNy42NDhsLTMwLjU5NC0xNy41MzR2NDIuMTEyYzAgMjEuNjQyIDQuNTQ0IDQyLjczIDEyLjk4MSA2MC4yNDJ6IiBmaWxsPSJ1cmwoI1NWR0lEXzFfKSIvPjxwYXRoIGQ9Im0xMzYuMzE5IDUxMGgyMC4yODRsMjUuMTA2LTUyLjEwN2M4LjQzOC0xNy41MTIgMTIuOTgyLTM4LjU5OSAxMi45ODItNjAuMjQydi00Mi4xMTJsLTMwLjU5NCAxNy41MzR2MTcuNjQ4YzAgMjYuMTQ3LTguMjc1IDUxLjYyMy0yMy42NCA3Mi43OGwtMTYuMzU3IDIyLjUyM2MtNy4yNSA5Ljk4My0uMTE5IDIzLjk3NiAxMi4yMTkgMjMuOTc2eiIgZmlsbD0idXJsKCNTVkdJRF8yXykiLz48cGF0aCBkPSJtMjczLjI4NiAzOTcuNjVjMCAyMS42NDMgMS4zNzggNDIuNzMgMy45MzYgNjAuMjQybDcuNjEzIDUyLjEwOGg2OC41NjJsLTI1LjEwNi01Mi4xMDdjLTguNDM4LTE3LjUxMi0xMi45ODItMzguNTk5LTEyLjk4Mi02MC4yNDJ2LTQyLjExMmwtNDIuMDIzLTI0LjA4NHoiIGZpbGw9InVybCgjU1ZHSURfM18pIi8+PHBhdGggZD0ibTE4MS43MSA0NTcuODkzLTI1LjEwNyA1Mi4xMDdoNjguNTYybDcuNjEyLTUyLjEwN2MyLjU1OC0xNy41MTIgMy45MzYtMzguNTk5IDMuOTM2LTYwLjI0MnYtNjYuMTk2bC00Mi4wMjMgMjQuMDg0djQyLjExMmMuMDAxIDIxLjY0Mi00LjU0MyA0Mi43My0xMi45OCA2MC4yNDJ6IiBmaWxsPSJ1cmwoI1NWR0lEXzRfKSIvPjxwYXRoIGQ9Im0yMzYuNzE0IDM5Ny42NWMwIDIxLjY0My0xLjM3OCA0Mi43My0zLjkzNiA2MC4yNDJsLTcuNjEzIDUyLjEwOGg1OS42NjlsLTcuNjEyLTUyLjEwN2MtMi41NTgtMTcuNTEyLTMuOTM2LTM4LjU5OS0zLjkzNi02MC4yNDJ2LTY2LjE5NmwtMTguMjg2LTEwLjQ4MS0xOC4yODYgMTAuNDh6IiBmaWxsPSJ1cmwoI1NWR0lEXzVfKSIvPjxwYXRoIGQ9Im0zNDUuOTAzIDM5MC43MnYtMTcuNjQ4bC0zMC41OTQtMTcuNTM0djQyLjExMmMwIDcuODEzLjYwMSAxNS41NSAxLjc1NSAyMy4wNzdoMzIuNTM2Yy0yLjQzOC05Ljc1OC0zLjY5Ny0xOS44My0zLjY5Ny0zMC4wMDd6IiBmaWxsPSJ1cmwoI1NWR0lEXzZfKSIvPjxwYXRoIGQ9Im0zMTUuMzA5IDM5Ny42NXYtNDIuMTEybC00Mi4wMjMtMjQuMDg0djY2LjE5NmMwIDcuODEzLjE4MiAxNS41NS41MzIgMjMuMDc3aDQzLjI0NWMtMS4xNTMtNy41MjYtMS43NTQtMTUuMjY0LTEuNzU0LTIzLjA3N3oiIGZpbGw9InVybCgjU1ZHSURfN18pIi8+PHBhdGggZD0ibTI3My44MTggNDIwLjcyN2MtLjM1LTcuNTI2LS41MzItMTUuMjY0LS41MzItMjMuMDc3di02Ni4xOTZsLTE4LjI4Ni0xMC40OC0xOC4yODYgMTAuNDh2NjYuMTk2YzAgNy44MTMtLjE4MiAxNS41NS0uNTMyIDIzLjA3N3oiIGZpbGw9InVybCgjU1ZHSURfOF8pIi8+PHBhdGggZD0ibTIzNi4xODIgNDIwLjcyN2MuMzUtNy41MjYuNTMyLTE1LjI2NC41MzItMjMuMDc3di02Ni4xOTZsLTQyLjAyMyAyNC4wODR2NDIuMTEyYzAgNy44MTMtLjYwMSAxNS41NS0xLjc1NSAyMy4wNzd6IiBmaWxsPSJ1cmwoI1NWR0lEXzlfKSIvPjxwYXRoIGQ9Im0xOTIuOTM3IDQyMC43MjdjMS4xNTQtNy41MjYgMS43NTUtMTUuMjY0IDEuNzU1LTIzLjA3N3YtNDIuMTEybC0zMC41OTQgMTcuNTM0djE3LjY0OGMwIDEwLjE3Ni0xLjI1OSAyMC4yNDktMy42OTYgMzAuMDA3eiIgZmlsbD0idXJsKCNTVkdJRF8xMF8pIi8+PC9nPjxnPjxnPjxwYXRoIGQ9Im0xNzEuMDM5IDM2MS4wOTJ2LTE1OC41MzRsLTU2LjE1NSA1Ni4xNTVjLTIzLjg5OSAyMy44OTktMzcuMzI2IDU2LjMxNC0zNy4zMjYgOTAuMTEzIDAgNi43NzQgNS40OTIgMTIuMjY2IDEyLjI2NiAxMi4yNjZ6IiBmaWxsPSJ1cmwoI1NWR0lEXzExXykiLz48cGF0aCBkPSJtMzM4Ljk2MSAzNjEuMDkydi0xNTguNTM0bDU2LjE1NSA1Ni4xNTVjMjMuOSAyMy44OTkgMzcuMzI2IDU2LjMxNCAzNy4zMjYgOTAuMTEzIDAgNi43NzQtNS40OTIgMTIuMjY2LTEyLjI2NiAxMi4yNjZ6IiBmaWxsPSJ1cmwoI1NWR0lEXzEyXykiLz48L2c+PHBhdGggZD0ibTIyMy42MDEgMTQuNDk4Yy00MS42MjMgNDguODUxLTY0LjQ4MyAxMTAuOTMtNjQuNDgzIDE3NS4xMDh2MTkwLjI0NGgxOTEuNzY1di0xOTAuMjQ1YzAtNjQuMTc4LTIyLjg2MS0xMjYuMjU3LTY0LjQ4My0xNzUuMTA4LTE2LjQ3MS0xOS4zMy00Ni4zMjktMTkuMzMtNjIuNzk5LjAwMXoiIGZpbGw9InVybCgjU1ZHSURfMTNfKSIvPjxwYXRoIGQ9Im0zNTAuODgzIDM3OS44NDl2LTE5MC4yNDRjMC02NC4xNzgtMjIuODYxLTEyNi4yNTctNjQuNDgzLTE3NS4xMDgtOC4yMzYtOS42NjQtMTkuODE4LTE0LjQ5Ny0zMS40LTE0LjQ5N3YzNzkuODQ5eiIgZmlsbD0idXJsKCNTVkdJRF8xNF8pIi8+PHBhdGggZD0ibTIwNy44MDkgMTI1LjcyMmMtMjcuMDY0IDI3LjA2NC0yOC44NzcgNjguMjI3LTEuODEzIDk1LjI5MWwxNDQuODg3IDE0NC44di0xNzYuMjA4YzAtNi44NzEtLjI3OC0xMy43MTUtLjc5Ny0yMC41MjRsLTQ2LjA3OS00Ni4wNzljLTI3LjA2NS0yNy4wNjQtNjkuMTM0LTI0LjM0NC05Ni4xOTggMi43MnoiIGZpbGw9InVybCgjU1ZHSURfMTVfKSIvPjxnPjxjaXJjbGUgY3g9IjI1NC43MTciIGN5PSIxNzIuMTk5IiBmaWxsPSJ1cmwoI1NWR0lEXzE2XykiIHI9IjUxLjI1MiIvPjxnPjxwYXRoIGQ9Im0zMDQuMDA3IDEyMy4wMDJjLTI3LjA2NC0yNy4wNjQtNzAuOTQ2LTI3LjA2NC05OC4wMSAwcy0yNy4wNjQgNzAuOTQ2IDAgOTguMDEgNzAuOTQxIDI3LjA1OSA5OC4wMDUtLjAwNSAyNy4wNjktNzAuOTQuMDA1LTk4LjAwNXptLTgyLjI5OCA4Mi4yOThjLTE4LjM5LTE4LjM5LTE4LjM4NC00OC4yMDEgMC02Ni41ODUgMTguMzktMTguMzkgNDguMTk1LTE4LjM5IDY2LjU4NSAwIDE4LjM4NCAxOC4zODQgMTguMzkgNDguMTk1IDAgNjYuNTg1LTE4LjM4NSAxOC4zODQtNDguMjAxIDE4LjM4NC02Ni41ODUgMHoiIGZpbGw9InVybCgjU1ZHSURfMTdfKSIvPjxwYXRoIGQ9Im0yODUuOTAyIDEyMS4yNjRjLTI4LjAyNS0xNy4wNjYtNjQuNTc3LTguMTgyLTgxLjY0MyAxOS44NDNzLTguMTc4IDY0LjU3MSAxOS44NDcgODEuNjM2YzI4LjAxOSAxNy4wNjIgNjQuNTY3IDguMTg0IDgxLjYzMi0xOS44NDFzOC4xODMtNjQuNTc2LTE5LjgzNi04MS42Mzh6bS01NS4zODcgOTAuOTU3Yy0yMi4yMTMtMTMuNTI2LTI5LjI0OC00Mi40OTUtMTUuNzI2LTY0LjcwMSAxMy41MjYtMjIuMjEzIDQyLjQ4OS0yOS4yNTIgNjQuNzAxLTE1LjcyNiAyMi4yMDYgMTMuNTIyIDI5LjI1MiA0Mi40ODkgMTUuNzI2IDY0LjcwMS0xMy41MjIgMjIuMjA2LTQyLjQ5NSAyOS4yNDgtNjQuNzAxIDE1LjcyNnoiIGZpbGw9InVybCgjU1ZHSURfMThfKSIvPjwvZz48L2c+PHBhdGggZD0ibTE1OS4xMTcgMjkxLjk4NWgxOTEuNzY1djU3Ljk3OGgtMTkxLjc2NXoiIGZpbGw9InVybCgjU1ZHSURfMTlfKSIvPjxwYXRoIGQ9Im0xNjEuNjQgMzg0LjE1aDE4Ni43MmM1LjczNyAwIDEwLjM4OC00LjY1MSAxMC4zODgtMTAuMzg4di0zMy4zMmMwLTUuNzM3LTQuNjUxLTEwLjM4OC0xMC4zODgtMTAuMzg4aC0xODYuNzJjLTUuNzM3IDAtMTAuMzg4IDQuNjUxLTEwLjM4OCAxMC4zODh2MzMuMzJjLS4wMDEgNS43MzcgNC42NSAxMC4zODggMTAuMzg4IDEwLjM4OHoiIGZpbGw9InVybCgjU1ZHSURfMjBfKSIvPjwvZz48L2c+PC9zdmc+";
export { SvgApps as ReactComponent };